import { wrapLazily } from "../lazy-loading/lazyWrapper";
export const routes = () => {
	return [
		{
			path: "/anon-cart",
			component: wrapLazily(() => import("oc_ui/AnonCartPage"), {
				usesBootstrap: true,
				usesMoment: false,
			}),
			routeParam: {
				trackingName: "anon-cart",
				noCustomerNeed: true,
				visibleForAnonymous: true,
			},
		},
		{
			path: "/anon-cart",
			childRoutes: [
				{
					path: "/anon-cart/debug",
					component: wrapLazily(() => import("oc_ui/AnonCartDebugPage"), {
						usesBootstrap: true,
						usesMoment: false,
					}),
					routeParam: {
						trackingName: "anon-cart-debug",
						noCustomerNeed: true,
						visibleForAnonymous: true,
					},
				},
			],
		},
		{
			path: "/abandoned-cart/:cartId",
			component: wrapLazily(() => import("oc_ui/AbandonedCartPage"), {
				usesBootstrap: true,
				usesMoment: false,
			}),
			routeParam: {
				trackingName: "abandoned-cart",
				noCustomerNeed: false,
			},
		},
		{
			path: "/cart",
			component: wrapLazily(() => import("oc_ui/CustomerCartPage"), {
				usesBootstrap: true,
				usesMoment: false,
			}),
			routeParam: {
				trackingName: "cart",
				noCustomerNeed: false,
			},
		},
		{
			path: "/order-entry",
			component: wrapLazily(() => import("oc_ui/OrderEntrySearchPage"), {
				usesBootstrap: true,
				usesMoment: false,
			}),
			routeParam: {
				trackingName: "order-entry:search",
				needsEmployee: true,
				noCustomerNeed: true,
			},
		},
		{
			path: "/order-entry",
			childRoutes: [
				{
					path: "/order-entry/search",
					component: wrapLazily(() => import("oc_ui/OrderEntrySearchPage"), {
						usesBootstrap: true,
						usesMoment: false,
					}),
					routeParam: {
						trackingName: "order-entry:search",
						needsEmployee: true,
						noCustomerNeed: true,
					},
				},
				{
					path: "/order-entry/new",
					component: wrapLazily(() => import("oc_ui/OrderEntryNewCartPage"), {
						usesBootstrap: true,
						usesMoment: false,
					}),
					routeParam: {
						trackingName: "order-entry:new",
						needsEmployee: true,
						noCustomerNeed: true,
					},
				},
				{
					path: "/order-entry/cart",
					component: wrapLazily(() => import("oc_ui/OrderEntryCartPage"), {
						usesBootstrap: true,
						usesMoment: false,
					}),
					routeParam: {
						trackingName: "order-entry:cart",
						needsEmployee: true,
						noCustomerNeed: true,
					},
				},
			],
		},
		{
			path: "/cart/print",
			component: wrapLazily(() => import("oc_ui/CartPdfPage"), {
				usesBootstrap: true,
				usesMoment: false,
			}),
			routeParam: {
				trackingName: "cart-print",
				noCustomerNeed: false,
			},
		},
		{
			path: "/checkout",
			component: wrapLazily(() => import("oc_ui/CheckoutInitPage"), {
				usesBootstrap: true,
				usesMoment: false,
			}),
			routeParam: {
				trackingName: "checkout:new",
				noCustomerNeed: true,
			},
		},
		{
			path: "/checkout",
			childRoutes: [
				{
					path: "/checkout/payments",
					component: wrapLazily(() => import("oc_ui/PaymentPage"), {
						usesBootstrap: true,
						usesMoment: false,
					}),
					childRoutes: [
						{
							path: "/checkout/payments/**",
						},
					],
					routeParam: {
						trackingName: "checkout:payment",
						noCustomerNeed: true,
					},
				},
				{
					path: "/checkout/delivery",
					component: wrapLazily(() => import("oc_ui/DeliveryPage"), {
						usesBootstrap: true,
						usesMoment: false,
					}),
					routeParam: {
						trackingName: "delivery",
						noCustomerNeed: true,
					},
				},
				{
					path: "/checkout/summary",
					component: wrapLazily(() => import("oc_ui/SummaryPage"), {
						usesBootstrap: true,
						usesMoment: false,
					}),
					childRoutes: [
						{
							path: "/checkout/summary/**",
						},
					],
					routeParam: {
						trackingName: "summary",
						noCustomerNeed: true,
					},
				},
				{
					path: "/checkout/success",
					component: wrapLazily(() => import("oc_ui/OrderConfirmationPage"), {
						usesBootstrap: true,
						usesMoment: false,
					}),
					routeParam: {
						trackingName: "checkout:order-confirmation",
						noCustomerNeed: true,
					},
				},
			],
		},
		{
			path: "/orderentry",
			component: wrapLazily(() => import("oc_ui/OrderEntrySearchPage"), {
				usesBootstrap: true,
				usesMoment: false,
			}),
			routeParam: {
				trackingName: "order-entry:search",
				needsEmployee: true,
				noCustomerNeed: true,
			},
		},
		{
			path: "/failed-submits",
			component: wrapLazily(() => import("oc_ui/FailedSubmitsPage"), {
				usesBootstrap: true,
				usesMoment: false,
			}),
			routeParam: {
				trackingName: "failed-submits",
				needsEmployee: true,
				noCustomerNeed: true,
			},
		},
		{
			path: "/saved-cart",
			component: wrapLazily(() => import("oc_ui/SavedCartPage"), {
				usesBootstrap: true,
				usesMoment: false,
			}),
			routeParam: {
				trackingName: "saved-cart",
				noCustomerNeed: false,
			},
		},
		{
			path: "/saved-carts",
			component: wrapLazily(() => import("oc_ui/SavedCartsListPage"), {
				usesBootstrap: true,
				usesMoment: false,
			}),
			routeParam: {
				trackingName: "saved-carts",
				noCustomerNeed: false,
			},
		},
		{
			path: "/ordercapture/support-tool",
			component: wrapLazily(() => import("oc_ui/SupportToolPage"), {
				usesBootstrap: true,
			}),
			routeParam: {
				trackingName: "oc-support-tool",
				needsEmployee: true,
				noCustomerNeed: true,
			},
		},
	];
};
